import { Navigate, useParams } from "react-router-dom";
import { FOUNDER_NAV_SECTIONS } from "../../founder/founderNavigation";
import { FounderAccountWorkspace } from "./workspaces/FounderAccountWorkspace";
import { FounderAppsWorkspace } from "./workspaces/FounderAppsWorkspace";
import { FounderMembershipsWorkspace } from "./workspaces/FounderMembershipsWorkspace";
import { FounderMarketplaceWorkspace } from "./workspaces/FounderMarketplaceWorkspace";
import { FounderOverviewWorkspace } from "./workspaces/FounderOverviewWorkspace";
import { FounderPlatformWorkspace } from "./workspaces/FounderPlatformWorkspace";
import { FounderPublishersWorkspace } from "./workspaces/FounderPublishersWorkspace";
import { FounderTrafficWorkspace } from "./workspaces/FounderTrafficWorkspace";

export function FounderSectionWorkspace() {
  const { sectionId } = useParams<{ sectionId: string }>();

  if (!sectionId) {
    return <Navigate replace to="overview" />;
  }

  const valid = FOUNDER_NAV_SECTIONS.some((section) => section.id === sectionId);
  if (!valid) {
    return <Navigate replace to="overview" />;
  }

  switch (sectionId) {
    case "overview":
      return <FounderOverviewWorkspace />;
    case "traffic":
      return <FounderTrafficWorkspace />;
    case "apps":
      return <FounderAppsWorkspace />;
    case "publishers":
      return <FounderPublishersWorkspace />;
    case "memberships":
      return <FounderMembershipsWorkspace />;
    case "marketplace":
      return <FounderMarketplaceWorkspace />;
    case "platform":
      return <FounderPlatformWorkspace />;
    case "account":
      return <FounderAccountWorkspace />;
    default:
      return <Navigate replace to="overview" />;
  }
}
